<template>
  
  <va-card title="Watched Accounts">
  
    <div class="row align--center">

        <div class="flex xs12 md6">
          <va-input
          v-model="term"
          :placeholder="$t('Search by display name')"
          >
          <va-icon name="fa fa-search" slot="prepend" />
          <va-button  small color="info" :disabled="term.length <= 0" @click="request" slot="append">
            {{ $t('Find') }}
          </va-button>
          <va-button  small color="success"  @click="clear" slot="append">
            {{ $t('Reset') }}
          </va-button>
          </va-input>
        </div>

      <div class="flex xs12 md6 text-right">
         <va-button color="info" :to="{ name: 'WatchedAccountCreate' }">Create watched account</va-button>
      </div>

    </div>

    <va-data-table
      :fields="fields"
      :data="data"
      :loading="loading"
      :totalPages="totalPages"
      @page-selected="request"
      api-mode
    >
      <template slot="created_at" slot-scope="props">
        {{Date(props.rowData.created_at)}}
      </template>

      <template slot="actions" slot-scope="props">
        <va-button  small color="danger" class="" @click="remove(props.rowData)">
          {{ $t('Remove') }}
        </va-button>
      </template>

    </va-data-table>
  </va-card>
 
</template>
<script>


import Table from '../../ui/table/Table'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    Table,
  },
  props: [],
  data () {
    return {
        paginate: 11,
        totalPages: 0,
        loading: false,
        term:""
    }
  },
  computed: {

    ...mapState({
        data: state => state.watched.accounts,
    }),

    /**
     * Fields map for data table
     * @var Array
     */
    fields () {
      return [
        {name: 'account_id',title: 'Account Id'},
        {name: 'display_name',title: 'Display Name'},
        {name: 'screen_name',title: 'Screen Name'},
        {name: '__slot:created_at',title: 'created at'},
        {name: '__slot:actions',title: 'Delete'},
      ]
    }

  },
  methods: {
    ...mapActions({
      fetch: 'paginateAccountsList',
      remove: 'removeAccount',
      craete: 'createAccount'
    }),

   /**
    * Request list of resources
    * @param Object payload
    * @return void
    */
    request(event){

      if(!Number.isInteger(event)) event = 1; 

      this.loading  = true
      let params    = { page: event, paginate:this.paginate, term:this.term }

      this.fetch(params).then( response => { 

        this.loading = false 
        this.totalPages = response.pages

      })

    },

   /**
    * Remove a single account for persitant 
    * datastore and local store
    * @param Object payload
    * @return Void()
    */
    delete(payload){

      this.loading = true;
      this.remove(payload).then( response => {
        this.loading = false 
      }).catch( error => console.log(error) )

    },

   /**
    * celar to remove params
    * @return void
    */
    clear(){
      this.term = ""
      this.request()
    },


  },
  mounted() { this.request() }
}
</script>
<style scoped>
</style>
